/*
 * @Author: monai
 * @Date: 2025-01-09 16:25:25
 * @LastEditors: monai
 * @LastEditTime: 2025-06-10 11:39:43
 */
const localConfig = {
    fnGetRequestDomain: () => { return DOMAIN.PROXY_API_ACTIVITY },
    fnGetWebSocketDomain: () => { return DOMAIN.MICO_ACTIVITY_WEBSOCKET_URI_NEW },
    fnGetSentryDsn: () => { return CONFIG.sentryDSN },
    fnGetImageInfo: () => undefined,
    fnGetConfig: (lang) => ({
        request: ['activity.micoworld.net'],
        websocket: ['activity-ws.micoworld.net'],
        sentryDSN: CONFIG.sentryDSN,
        gameDomain: 'web-app.micoworld.net'
    })
};

if(ENV === 'build' || ENV === 'build_dev') {
    // dynamicConfig-build_dev.v1.js
    // dynamicConfig-build.v1.js
    const fileName = `dynamicConfig-${ENV}.v1.js`;
    const xhr = new XMLHttpRequest();
    xhr.open('GET', DOMAIN.H5_CORS_STATIC + `/js/${fileName}`, false);
    xhr.setRequestHeader('Cache-Control', 'max-age=0');
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.text = xhr.responseText;
                document.head.appendChild(script);
            } else {
                console.error(`[${new Date().toLocaleString()}] - 获取请求域名 JS 文件失败！`, xhr.statusText);
                window.ACTIVITY_H5_CONFIG = localConfig;
            }
        }
    };
    xhr.onerror = function (e) {
        console.error(`[${new Date().toLocaleString()}] - 获取请求域名 JS 文件失败！`, xhr.statusText);
    };
    xhr.send(null);
}
// 测试、本地直接使用本地配置
else {
    window.ACTIVITY_H5_CONFIG = localConfig;
}